import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const vendorAccessLevelSchema = createEnum(["CAMPAIGN", "MARKETPLACE"]);
export const VendorAccessLevelEnum = vendorAccessLevelSchema.enum;

export type VendorAccessLevel = z.infer<typeof vendorAccessLevelSchema>;

export const marketplaceCampaignBrandingSchema = z.object({
  title: z.string(),
  subtitle: z.string().nullable(),
  logoUrl: z.string().nullable(),
  primaryColor: z.string().nullable(),
  backgroundImage: z.string().nullable(),
  customCss: z.string().nullable(),
});

export const marketplaceCampaignStatsSchema = z.object({
  totalLogins: z.number(),
  uniqueUsers: z.number(),
});

export const marketplaceCampaignSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  catalogId: z.string(),
  startTime: z.date(),
  endTime: z.date(),
  timezone: z.string(),
  active: z.boolean(),
  maxUsers: z.number().nullable(),
  allowedDomains: z.array(z.string()),
  branding: marketplaceCampaignBrandingSchema.nullable(),
  stats: marketplaceCampaignStatsSchema.nullable(),
});

export type MarketplaceCampaign = z.infer<typeof marketplaceCampaignSchema>;
export type MarketplaceCampaignBranding = z.infer<
  typeof marketplaceCampaignBrandingSchema
>;
export type MarketplaceCampaignStats = z.infer<
  typeof marketplaceCampaignStatsSchema
>;
